import { Suspense } from "react";
import { Outlet, Navigate } from "react-router-dom";
import AuthLayout from "../Layout/AuthLayout";
import SplashLoader from "../ui/SplashLoader";
import { useAuth } from "../../Lib/Hooks/AuthHooks";
// import SplashLoader from "../../components/ui/loader";

const PublicRoutes = () => {
  const { authenticated, loginRedirect } = useAuth();
  return !authenticated ? (
    <>
      {/* <Suspense fallback={<SplashLoader />}> */}
      {/* <AuthLayout> */}
      <Outlet />
      {/* </AuthLayout> */}
      {/* </Suspense> */}
    </>
  ) : (
    <Navigate to={loginRedirect} />
  );
};

export default PublicRoutes;
